import { Button } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
import * as React from 'react';

export const FormButton = (props: ButtonProps) => (
  <Button type="submit" {...props} />
);
